import React from "react";
import Form from "./Form";
import { Link } from "react-router-dom";

function Contact() {
  const locationUrl =
    "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3399.4810458977!2d74.32244751515178!3d31.565853881354606!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzHCsDMzJzU3LjEiTiA3NMKwMTknMjguNyJF!5e0!3m2!1sen!2s!4v1689429917718!5m2!1sen!2s";
  return (
    <div className="contact  py-10 xl:px-32 lg:px-24 md:px-16 px-10  ">
      <h1 className="text-center  xl:text-4xl lg:text-3xl md:text-2xl text-xl pb-10">
        Get in touch...
      </h1>
      <iframe
        title="Google Maps"
        src={locationUrl}
        className="h-[40vh] bg-black w-full "
        allowfullscreen={true}
        referrerPolicy="no-referrer-when-downgrade"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
      {/* <iframe
        src="https://api.accredible.com/v1/frontend/credential_website_embed_image/certificate/77907628"
        width="800"
        height="600"
        frameborder="0"
        allowfullscreen
        title="Google Analytics Certification"
      ></iframe> */}

      <div className="contact_details grid md:grid-cols-2 grid-cols-1 gap-x-20 py-10">
        <div className="contact_data text-base opacity-75 font-light space-y-4">
          <p className="">
            Don’t hesitate to call by or get in touch if you have any questions,
            we will be happy to help with anything you might need.
          </p>
          <p className="">
            <span className="text-black opacity-100 font-medium">
              Address:{" "}
            </span>
            Shop # 05 First Floor Masjid Khulfa-e-Rashideen Royal Park, Lakhsmi
            Chowk, Lahore, Pakistan.54000
          </p>
          <p>
            <span className="text-black opacity-100 font-medium">Email: </span>
            <Link to="mailto:ahsan@keylinesolution.com">
              ahsan@keylinesolution.com
            </Link>
          </p>
          <p>
            <span className="text-black opacity-100 font-medium">
              Whatsapp:{" "}
            </span>
            <Link to="https://wa.link/st8kay">+92 333 448 7714</Link>
          </p>
          <div className="opening Hours">
            <h2 className="text-2xl">Opening Hours:</h2>
            <ul className="py-3">
              <li>Monday 9.00am – 5.00pm</li>
              <li>Tuesday 9.00am – 5.00pm</li>
              <li>Wednesday 9.00am – 5.00pm</li>
              <li>Thursday 9.00am – 5.00pm</li>
              <li>Friday 10.00am – 01.00pm</li>
              <li>Saturday 9.00am – 5.00pm</li>
              <li>Sunday Closed</li>
            </ul>
          </div>
        </div>
        <div className="">
          <h2 className="xl:text-3xl lg:text-2xl text-xl pb-5 ">
            Contact us...
          </h2>
          <form
            className="w-full"
            action="https://formsubmit.co/mafaqsaad51@gmail.com"
            method="POST"
            enctype="multipart/form-data"
          >
            <div className="form_inputs flex flex-col w-full space-y-2 text-sm">
              <Form />
              <input
                type="hidden"
                name="_subject"
                value="mail from keylinesolution CONTACT PAGE "
              />
              <button
                type="submit"
                className="border-2 w-full border-black text-sm hover:text-black  py-2 px-8 bg-black hover:bg-transparent text-white transition-all mt-4"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <p className="text-center opacity-70 px-10">
        {" "}
        We aim to reply to all of our emails within 24 hours (within our opening
        hours), if you do not have a reply within that time please resend the
        email to ahsan@keylinesolution.com
      </p>
    </div>
  );
}

export default Contact;
